export const ATTRIBUTES = {
    CURRENT_FORMAT: 'current-format',
    SHOW_VALUE: 'show-value',
    LABEL_TITLE: 'label-title',
    LABEL_VALUE: 'label-value',
};

export const PROPS = {
    CURRENT: 'current',
    LIMIT: 'limit',
    SHOW_VALUE: 'showValue',
};
